(function () {
    "use strict";

    angular.module("app").component("habilSelectAll", {
        bindings: { onToggle: "&" },
        template: `
            <input type="checkbox"
                   ng-model="$ctrl.isChecked"
                   ng-change="$ctrl.onChange()"
                   ng-attr-title="{{$ctrl.title | habilTranslation}}">`,
        controller: SelectAllController
    });

    function SelectAllController() {
        
        const $controller = this;

        Object.defineProperty($controller, "title", { get: () => $controller.isChecked ? "Shared_DeselectAll_Label" : "Shared_SelectAll_Label" });
        $controller.onChange = toggle;
        $controller.isChecked = false;

        function toggle() {
            console.log($controller.isChecked);
            $controller.onToggle({ newState: $controller.isChecked });
        }
    }
})();
